// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2vfc7","container":"styles_container__22445","title":"styles_title__j1wPL","wrapper":"styles_wrapper__3tpoL","answer":"styles_answer__1u_6k"};